import { Pagination } from '@material-ui/lab';
import { ReactElement } from 'react';

export interface ICoMaPagingBar {
	total: number;
	pageIndex: number;
	onPageChange: (pageIndex: number) => void;
}

export function CoMaPagingBar(props: ICoMaPagingBar): ReactElement {
	const { total, pageIndex, onPageChange } = props;
	return (
		<Pagination
			className="coma-overview-paging"
			onChange={(_, page: number) => onPageChange(page - 1)}
			color="primary"
			count={total}
			page={pageIndex + 1}
			size="large"
		/>
	);
}
